import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/footer";
import { IMAGES } from "../../constant/Image";
import Banner from "../../components/TitleBanner/index";
import { FaPhoneAlt } from "react-icons/fa";
import { BsEnvelopeFill } from "react-icons/bs";
import { FaMapMarkerAlt } from "react-icons/fa";

const Contact = () => {
  return (
    <div>
      <Header />
      <Banner
        title="Contact Us"
        bgImage={IMAGES.ContactUsBannerbg}
        breadcrumbs={["Contact Us"]}
      />

      <section className="contact-us-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="about-links">
                <div className="icon-box">
                  <div className="text">
                    <h6>To Know More</h6>
                  </div>
                  <ul>
                    <li>
                      {" "}
                      <div className="icon-i">
                        <FaPhoneAlt />
                      </div>
                      <div className="links">
                        <a href="tel:+123 456 7899">+123 456 7899</a>
                        <a href="tel:+123 456 7899">+123 456 7899</a>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="icon-box">
                  <div className="text">
                    <h6>Email Now</h6>
                  </div>
                  <ul>
                    <li>
                      <div className="icon-i">
                        {" "}
                        <BsEnvelopeFill />{" "}
                      </div>
                      <div className="links">
                        <a href="mailto:info@example.com">info@example.com</a>
                        <a href="mailto:example@example.com">example@example.com</a>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="icon-box">
                  <div className="text">
                    <h6>Location</h6>
                  </div>
                  <ul>
                    <li>
                      <div className="icon-i">
                        <FaMapMarkerAlt />{" "}
                      </div>
                      <div className="links">
                        <a href="/">
                          9528 25 Hwy/ Halton Hills/ <br /> Ontario/ Canada
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-8">
              <div className="form-box">
                <form action="">
                  <div className="two-inputs-align">
                    <div className="box">
                      <label htmlFor="">First Name</label>
                      <input type="text" placeholder="William" />
                    </div>
                    <div className="box">
                      <label htmlFor="">Last Name</label>
                      <input type="text" placeholder=" Scott" />
                    </div>
                  </div>
                  <div className="two-inputs-align">
                    <div className="box">
                      <label htmlFor="">Phone</label>
                      <input type="tel" placeholder="+123 456 7899" />
                    </div>
                    <div className="box">
                      <label htmlFor="">Email Address</label>
                      <input type="email" placeholder=" info@example.com" />
                    </div>
                  </div>
                  <div className="full-input">
                    <div className="box">
                      <label htmlFor="">Write Your Massage</label>
                      <textarea
                        name=""
                        id=""
                        placeholder="Whats in your mind"
                      ></textarea>
                    </div>
                  </div>
                  <button actions="submit">Submit Now</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="iframe-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div style={{ width: "100%", height: "450px" }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d20359.798654993767!2d-101.68538966161542!3d57.78756041419294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4b0d03d337cc6ad9%3A0x9968b72aa2438fa5!2sCanada!5e1!3m2!1sen!2s!4v1755506554823!5m2!1sen!2s"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Map"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
